import { Filter } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFilter12Line = createIcon(Filter, 12, "Line");
export const IconFilter16Line = createIcon(Filter, 16, "Line");
export const IconFilter20Line = createIcon(Filter, 20, "Line");
export const IconFilter24Line = createIcon(Filter, 24, "Line");
export const IconFilter32Line = createIcon(Filter, 32, "Line");
export const IconFilter48Line = createIcon(Filter, 48, "Line");
export const IconFilter64Line = createIcon(Filter, 64, "Line");
